export const Loading = () => {
    return (
        <span className="text-primary ps-2">
            <strong className="pe-2">Loading...</strong>
            <span className="spinner-border spinner-border-sm ms-auto" role="status" aria-hidden="true"></span>
        </span>
    );
};
